import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { SmsSmartComponent } from './sms-smart/sms-smart.component';
import { SmsCreateComponent } from './sms-create/sms-create.component';
import { TranscriptModule } from 'app/transcript/transcript.module';
import { QuillModule } from 'ngx-quill';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { CrossSellDialogComponent } from './cross-sell-dialog/cross-sell-dialog.component';
import { NgxsModule } from '@ngxs/store';
import { TemplatePickerModule } from 'app/modules/template-picker/template-picker.module';



@NgModule({
  declarations: [
    CrossSellDialogComponent,
    SmsSmartComponent,
    SmsCreateComponent
  ],
  imports: [
    AlertModule,
    CommonModule,
    FormsModule,
    TemplatePickerModule,
    TranscriptModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    MatRadioModule,
    NgxsModule,
    PickerModule,
    EmojiModule,
    QuillModule.forRoot({
      placeholder: 'Type a new text message...',
    }),
    MatProgressSpinnerModule
  ],
  exports: [
    SmsSmartComponent
  ]
})
export class SmsModule { }
